
import { useEffect, useState } from 'react';
import styles from './list.module.css';
import { Button, IconButton, Dialog, DialogTitle, DialogContent, Snackbar, Alert, Breadcrumbs, Typography, Checkbox } from '@mui/material';
import { Add, Close } from '@mui/icons-material';
import AddPermissionForm from './AddPermissionForm';
import axios from 'axios';
import Loader from '../../components/Loader';
import { TableLoader } from '../../components/ContentLoader';
import { authData, withAdminAuth } from "../../components/GetAuth";

const ChildPermList = ({ perm, roleList, cngStatus }) => {
  const auth = authData();

  return <tr style={{ height: '30px' }}>
    {auth?.user_type === 1 && <td style={{ borderBottom: '1px solid #C0C0C0', width: '500px', paddingLeft: '50px', fontSize: '14px', fontWeight: 500 }}>{perm?.name} (<strong>{perm?.slug}</strong>)</td>}
    {auth?.user_type !== 1 && <td style={{ borderBottom: '1px solid #C0C0C0', width: '500px', paddingLeft: '50px', fontSize: '14px', fontWeight: 500 }}>{perm?.name}</td>}
    {roleList?.map(i => {
      return <td key={i?.id} style={{ borderBottom: '1px solid #C0C0C0' }}>
        <Checkbox disabled={i?.id === 2} defaultChecked={i?.permissions?.indexOf(perm?.id) > -1} onChange={(e) => cngStatus(e, i?.id, perm?.id)} />
      </td>
    })}
  </tr>
}

const UserList = () => {
  const auth = authData();
  const API_TOKEN = auth?.api_token;
  const [loading, setLoading] = useState(false);
  const [contentLoading, setContentLoading] = useState(true);
  const [formOpen, setFormOpen] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarType, setSnackbarType] = useState('success');
  const [permissionList, setPermissionList] = useState([]);
  const [roleList, setRoleList] = useState([]);

  useEffect(() => {
    const fetchPerms = () => {
      axios.get(process.env.REACT_APP_API_URL + 'v1/user-permissions', {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`,
        }
      }).then(response => {
        setContentLoading(false);
        setPermissionList(response.data.data);
      }).catch(eroor => {
        setContentLoading(false);
      });
    }

    fetchPerms();
  }, [API_TOKEN]);

  useEffect(() => {
    const fetchRoles = () => {
      axios.get(process.env.REACT_APP_API_URL + 'v1/user-role-list', {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`,
        }
      }).then(response => {
        setContentLoading(false);
        setRoleList(response.data.data);
      }).catch(error => {
        setContentLoading(false);
      });
    }

    fetchRoles();
  }, [API_TOKEN]);

  const cngStatus = (e, roleId, permId) => {
    let postData = { role_id: roleId, permission_id: permId };
    setLoading(true);
    if (e.target.checked) {
      axios.post(process.env.REACT_APP_API_URL + 'v1/add-role-perm', postData, {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`,
        }
      }).then(response => {
        setLoading(false);
      }).catch(error => {
        setLoading(false);
      });
    } else {
      axios.post(process.env.REACT_APP_API_URL + 'v1/del-role-perm', postData, {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`,
        }
      }).then(response => {
        setLoading(false);
      }).catch(error => {
        setLoading(false);
      });
    }
  }


  return (<>
    <Loader open={loading} setOpen={setLoading.bind(this)} />
    <div className={`${styles.MainDiv}`}>
      <div className={`${styles.PageTitleWrap}`}>
        <p className={`${styles.PageTitle}`}>User Permissions</p>
        <Breadcrumbs aria-label="breadcrumb" className='breadcrumb'>
          <Typography color="text.primary">User Permissions</Typography>
        </Breadcrumbs>
      </div>
      <div className={`${styles.MainCard}`}>
        {contentLoading && <TableLoader />}
        {!contentLoading && <>
          {auth?.user_type === 1 && <div className='TableFilterHead' style={{ justifyContent: 'end' }}>
            <div className='TableFilterBUSec'>
              <Button className="TableAddBU" onClick={(e) => { setFormOpen(true); }} style={{ width: '142px' }}><Add /> Permissions</Button>
            </div>
          </div>}

          <div>
            <table style={{ width: '100%' }}>
              <tbody class="text-gray-600 fw-semibold">
                <tr style={{ height: '60px' }}>
                  <td style={{ borderBottom: '1px solid #C0C0C0', width: '500px' }}>&nbsp;</td>
                  {roleList?.map(i => {
                    return <td key={i?.id} style={{ borderBottom: '1px solid #C0C0C0', fontSize: '16px', fontWeight: 600 }}>{i?.name}</td>
                  })}
                </tr>
                {permissionList?.map(i => {
                  return <>
                    <tr style={{ height: '60px' }}>
                      <td style={{ borderBottom: '1px solid #C0C0C0', width: '400px', fontSize: '16px', fontWeight: 600 }}>{i?.name}</td>
                      {roleList?.map(i => {
                        return <td key={i?.id} style={{ borderBottom: '1px solid #C0C0C0' }}>&nbsp;</td>
                      })}
                    </tr>
                    {i?.childrens?.map(j => {
                      return <ChildPermList perm={j} roleList={roleList} cngStatus={cngStatus.bind(this)} />
                    })}
                  </>
                })}

              </tbody>
            </table>
          </div>
        </>}
      </div>
    </div>

    <Dialog
      open={formOpen}
      onClose={(e) => setFormOpen(false)}
    >
      <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">Add User Permission</DialogTitle>
      <IconButton aria-label="close" onClick={(e) => setFormOpen(false)} sx={{ position: 'absolute', right: 8, top: 8 }}> <Close /></IconButton>
      <DialogContent>
        <AddPermissionForm setFormOpen={setFormOpen.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} setSnackbarMessage={setSnackbarMessage.bind(this)} setSnackbarType={setSnackbarType.bind(this)} setLoading={setLoading.bind(this)} />
      </DialogContent>
    </Dialog>

    <Snackbar
      open={snackbarOpen}
      autoHideDuration={6000}
      onClose={(e) => setSnackbarOpen(false)}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Alert
        onClose={(e) => setSnackbarOpen(false)}
        severity={snackbarType}
        variant="filled"
        sx={{ width: '100%' }}
      >
        {snackbarMessage}
      </Alert>
    </Snackbar>
  </>);
}

export default withAdminAuth(UserList);